module.exports = __webpack_public_path__ + "static/media/partnerships-bg-new.e7ca2758.png";